import router from './index'
import NProgress from 'nprogress'
import store from '@/store'
import { getPageTitle } from '@/utils/index'

router.beforeEach(async (to, from, next) => {
  // set page title
  document.title = getPageTitle(to.meta.title)
  // start progress bar
  NProgress.start()
  // 用户已经登录
  if (store.getters.hasLogin) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({ path: '/administration/users' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    // 用户没有登录
    if (to.meta.requiresAuth) {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done()
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
